var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form-item',{staticClass:"mb-0"},[_c('a-radio-group',{directives:[{name:"decorator",rawName:"v-decorator",value:(_vm.decorator),expression:"decorator"}]},_vm._l((_vm.opts),function(item){return _c('a-radio-button',{key:item.key,attrs:{"value":item.key}},[_vm._v(_vm._s(item.label))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }